import styles from './PaymentSuccess.module.scss';
import Card from 'components/Card';
import CardContent from 'components/CardContent';
import {useRef} from 'react';
import Typography from 'components/Typography';
import classNames from 'classnames';
import successImg from '../../payment_success_icon.png';
import {get} from 'lodash';
import PrintIcon from 'icons/PrintIcon';
import ReactToPrint from 'react-to-print';
import StatusBadge from 'components/StatusBadge';

function PaymentSuccess({datas}: {datas: any}) {
  const printRef = useRef<any>(null);
  return (
    <>
      <Card className={styles.card}>
        <CardContent pt="sm" className={styles.cardContent}>
          <div ref={printRef}>
            <div className={styles.successContainer}>
              <img
                className={styles.successImg}
                src={successImg}
                alt="Success"
              />
              <Typography variant="h2" textAlign="center">
                Successfully paid!
              </Typography>
              <Typography variant="label" className={styles.labe}>
                Thank you for the purchase
              </Typography>
            </div>

            <div className={styles.row}>
              <Typography className={classNames(styles.label)} variant="label">
                Customer
              </Typography>
              <Typography className={classNames(styles.text)} variant="p">
                {get(datas, 'request.customer')}
              </Typography>
            </div>
            <div className={styles.row}>
              <Typography className={classNames(styles.label)} variant="label">
                Product Name
              </Typography>
              <Typography className={classNames(styles.text)} variant="p">
                {get(datas, 'request.drug_name')}
              </Typography>
            </div>

            <div className={styles.row}>
              <Typography className={classNames(styles.label)} variant="label">
                Order #
              </Typography>
              <Typography className={classNames(styles.text)} variant="p">
                {get(datas, 'request.sequential_order_number')}
              </Typography>
            </div>

            <div className={styles.row}>
              <Typography className={classNames(styles.label)} variant="label">
                Payment amount
              </Typography>
              <Typography className={classNames(styles.text)} variant="p">
                ${get(datas, 'request.amount_due')}
              </Typography>
            </div>

            <div className={styles.row}>
              <Typography className={classNames(styles.label)} variant="label">
                Status
              </Typography>

              <StatusBadge color="green">Paid</StatusBadge>
            </div>
          </div>

          <div className={styles.printContent}>
            <ReactToPrint
              pageStyle={'@page { size: auto; margin: 20mm; }'}
              trigger={() => (
                <button className={styles.printAction}>
                  <PrintIcon size={16} />
                </button>
              )}
              content={() => printRef.current}
            />
          </div>
        </CardContent>
      </Card>
    </>
  );
}
export default PaymentSuccess;
